export default[
      {
        "make":"ACURA",
        "model":"CL",
        "replaceby":"CL"
      },
      {
        "make":"ACURA",
        "model":"2.2CL",
        "replaceby":"CL"
      },

      {
        "make":"ACURA",
        "model":"TL",
        "replaceby":"TL"
      },
      {
        "make":"ACURA",
        "model":"2.5TL",
        "replaceby":"TL"
      },
      {
        "make":"ACURA",
        "model":"3.2TL",
        "replaceby":"TL"
      },
      {
        "make":"ACURA",
        "model":"3.5",
        "replaceby":"TL"
      },

      {
        "make":"AMERICAN MOTORS",
        "model":"HUMMER",
        "replaceby":"HUMMER"
      },
      {
        "make":"AMERICAN MOTORS",
        "model":"H3T",
        "replaceby":"HUMMER"
      },
      {
        "make":"AMERICAN MOTORS",
        "model":"HUMMER H1",
        "replaceby":"HUMMER"
      },

      {
        "make":"AUDI",
        "model":"100",
        "replaceby":"100"
      },
      {
        "make":"AUDI",
        "model":"100 QUATTRO",
        "replaceby":"100"
      },
      {
        "make":"AUDI",
        "model":"100 SERIES",
        "replaceby":"100"
      },
      {
        "make":"AUDI",
        "model":"200",
        "replaceby":"200"
      },
      {
        "make":"AUDI",
        "model":"200 QUATTRO",
        "replaceby":"200"
      },
      {
        "make":"AUDI",
        "model":"4000",
        "replaceby":"4000"
      },
      {
        "make":"AUDI",
        "model":"4000 QUATTRO",
        "replaceby":"4000"
      },
      {
        "make":"AUDI",
        "model":"5000",
        "replaceby":"5000"
      },
      {
        "make":"AUDI",
        "model":"5000 QUATTRO",
        "replaceby":"5000"
      },
      {
        "make":"AUDI",
        "model":"80",
        "replaceby":"80"
      },
      {
        "make":"AUDI",
        "model":"80 QUATTRO",
        "replaceby":"80"
      },
      {
        "make":"AUDI",
        "model":"90",
        "replaceby":"90"
      },
      {
        "make":"AUDI",
        "model":"90 QUATTRO",
        "replaceby":"90"
      },

      {
        "make":"AUDI",
        "model":"A3",
        "replaceby":"A3"
      },
      {
        "make":"AUDI",
        "model":"A3 ETRON",
        "replaceby":"A3"
      },
      {
        "make":"AUDI",
        "model":"A3 QUATTRO",
        "replaceby":"A3"
      },
      {
        "make":"AUDI",
        "model":"A3 SPORTBACK_ETRON",
        "replaceby":"A3"
      },
      {
        "make":"AUDI",
        "model":"A4",
        "replaceby":"A4"
      },
      {
        "make":"AUDI",
        "model":"A4 ALLROAD",
        "replaceby":"A4"
      },
      {
        "make":"AUDI",
        "model":"A4 QUATTRO",
        "replaceby":"A4"
      },
      {
        "make":"AUDI",
        "model":"A5",
        "replaceby":"A5"
      },
      {
        "make":"AUDI",
        "model":"A5 QUATTRO",
        "replaceby":"A5"
      },
      {
        "make":"AUDI",
        "model":"A6",
        "replaceby":"A6"
      },
      {
        "make":"AUDI",
        "model":"A6 QUATTRO",
        "replaceby":"A6"
      },
      {
        "make":"AUDI",
        "model":"A7",
        "replaceby":"A7"
      },
      {
        "make":"AUDI",
        "model":"A7 QUATTRO",
        "replaceby":"A7"
      },
      {
        "make":"AUDI",
        "model":"A8",
        "replaceby":"A8"
      },
      {
        "make":"AUDI",
        "model":"A8 QUATTRO",
        "replaceby":"A8"
      },
      {
        "make":"AUDI",
        "model":"ALLROAD",
        "replaceby":"ALLROAD"
      },
      {
        "make":"AUDI",
        "model":"ALLROAD QUATTRO",
        "replaceby":"ALLROAD"
      },
      {
        "make":"AUDI",
        "model":"COUPE",
        "replaceby":"COUPE"
      },
      {
        "make":"AUDI",
        "model":"COUPE QUATTRO",
        "replaceby":"COUPE"
      },

      {
        "make":"AUDI",
        "model":"Q3",
        "replaceby":"Q3"
      },
      {
        "make":"AUDI",
        "model":"Q3 QUATTRO",
        "replaceby":"Q3"
      },
      {
        "make":"AUDI",
        "model":"Q5",
        "replaceby":"Q5"
      },
      {
        "make":"AUDI",
        "model":"Q5 HYBRID",
        "replaceby":"Q5"
      },

      {
        "make":"AUDI",
        "model":"TT",
        "replaceby":"TT"
      },
      {
        "make":"AUDI",
        "model":"TT QUATTRO",
        "replaceby":"TT"
      },
      {
        "make":"AUDI",
        "model":"TT RS",
        "replaceby":"TT"
      },

      {
        "make":"BUICK",
        "model":"CENTURY",
        "replaceby":"CENTURY"
      },
      {
        "make":"BUICK",
        "model":"CENTURY CLASS",
        "replaceby":"CENTURY"
      },

      {
        "make":"BUICK",
        "model":"GS",
        "replaceby":"GRAN SPORT"
      },
      {
        "make":"BUICK",
        "model":"GS 350",
        "replaceby":"GRAN SPORT"
      },
      {
        "make":"BUICK",
        "model":"GS 400",
        "replaceby":"GRAN SPORT"
      },
      {
        "make":"BUICK",
        "model":"GS 455",
        "replaceby":"GRAN SPORT"
      },

      {
        "make":"BUICK",
        "model":"REGENCY",
        "replaceby":"REGENCY"
      },
      {
        "make":"BUICK",
        "model":"REGENCY 98",
        "replaceby":"REGENCY"
      },

      {
        "make":"BUICK",
        "model":"SOMERSET",
        "replaceby":"SOMERSET"
      },
      {
        "make":"BUICK",
        "model":"SOMERSET REGAL",
        "replaceby":"SOMERSET"
      },

      {
        "make":"CADILLAC",
        "model":"ESCALADE",
        "replaceby":"ESCALADE"
      },
      {
        "make":"CADILLAC",
        "model":"ESCALADE ESV",
        "replaceby":"ESCALADE"
      },
      {
        "make":"CADILLAC",
        "model":"ESCALADE EXT",
        "replaceby":"ESCALADE"
      },

      {
        "make":"CADILLAC",
        "model":"FLEETWOOD",
        "replaceby":"FLEETWOOD"
      },
      {
        "make":"CADILLAC",
        "model":"SERIES 60_FLEETWOOD",
        "replaceby":"FLEETWOOD"
      },

      {
        "make":"CADILLAC",
        "model":"SEDAN",
        "replaceby":"SEDAN"
      },
      {
        "make":"CADILLAC",
        "model":"SEDAN DE VILLE",
        "replaceby":"SEDAN"
      },

      {
        "make":"CADILLAC",
        "model":"SERIES 75",
        "replaceby":"SERIES 75"
      },
      {
        "make":"CADILLAC",
        "model":"SERIES 75_FLEETWOOD",
        "replaceby":"SERIES 75"
      },

      {
        "make":"CADILLAC",
        "model":"XLR",
        "replaceby":"XLR"
      },
      {
        "make":"CADILLAC",
        "model":"XLR-V",
        "replaceby":"XLR"
      },
      {
        "make":"CADILLAC",
        "model":"XT5",
        "replaceby":"XT5"
      },
      {
        "make":"CADILLAC",
        "model":"XTS PRO",
        "replaceby":"XT5"
      },

      {
        "make":"CHRYSLER",
        "model":"300",
        "replaceby":"300"
      },
      {
        "make":"CHRYSLER",
        "model":"300M",
        "replaceby":"300"
      },
      {
        "make":"CHRYSLER",
        "model":"300 M",
        "replaceby":"300"
      },
      {
        "make":"CHRYSLER",
        "model":"300C",
        "replaceby":"300"
      },
      {
        "make":"CHRYSLER",
        "model":"ARROW",
        "replaceby":"ARROW"
      },
      {
        "make":"CHRYSLER",
        "model":"ARROW PICKUP",
        "replaceby":"ARROW"
      },

      {
        "make":"CHRYSLER",
        "model":"DE SOTO",
        "replaceby":"DE SOTO"
      },
      {
        "make":"CHRYSLER",
        "model":"DESOTO",
        "replaceby":"DE SOTO"
      },

      {
        "make":"CHRYSLER",
        "model":"FIFTH AVENUE",
        "replaceby":"FIFTH AVENUE"
      },
      {
        "make":"CHRYSLER",
        "model":"FIFTH AVE",
        "replaceby":"FIFTH AVENUE"
      },


      {
        "make":"CHRYSLER",
        "model":"NEW YORKER",
        "replaceby":"NEW YORKER"
      },
      {
        "make":"CHRYSLER",
        "model":"NEW YORKER_(RWD)",
        "replaceby":"NEW YORKER"
      },

      {
        "make":"CHRYSLER",
        "model":"VISTA",
        "replaceby":"VISTA"
      },
      {
        "make":"CHRYSLER",
        "model":"VVISTA HATCHBACK",
        "replaceby":"VISTA"
      },

      {
        "make":"FIAT",
        "model":"1500",
        "replaceby":"1500"
      },
      {
        "make":"FIAT",
        "model":"1500 SERIES",
        "replaceby":"1500"
      },
      {
        "make":"FIAT",
        "model":"500",
        "replaceby":"500"
      },
      {
        "make":"FIAT",
        "model":"500L",
        "replaceby":"500"
      },
      {
        "make":"FIAT",
        "model":"500 ABARTH",
        "replaceby":"500"
      },
      {
        "make":"FIAT",
        "model":"500C",
        "replaceby":"500"
      },
      {
        "make":"FIAT",
        "model":"500X",
        "replaceby":"500"
      },

      {
        "make":"HONDA",
        "model":"ACCORD",
        "replaceby":"ACCORD"
      },
      {
        "make":"HONDA",
        "model":"ACCORD CROSSTOUR",
        "replaceby":"ACCORD"
      },
      {
        "make":"HONDA",
        "model":"ACCORD WAGON",
        "replaceby":"ACCORD"
      },
      {
        "make":"HONDA",
        "model":"CIVIC",
        "replaceby":"CIVIC"
      },
      {
        "make":"HONDA",
        "model":"CIVIC DEL_SOL",
        "replaceby":"CIVIC"
      },
      {
        "make":"HONDA",
        "model":"CIVIC CRX",
        "replaceby":"CIVIC"
      },
      {
        "make":"HONDA",
        "model":"CIVIC DEL SOL",
        "replaceby":"CIVIC"
      },
      {
        "make":"HONDA",
        "model":"CIVIC HATCHBACK",
        "replaceby":"CIVIC"
      },
      {
        "make":"HONDA",
        "model":"CIVIC WAGON",
        "replaceby":"CIVIC"
      },

      {
        "make":"HONDA",
        "model":"CRX",
        "replaceby":"CRX"
      },
      {
        "make":"HONDA",
        "model":"CRX CIVIC",
        "replaceby":"CRX"
      },
      {
        "make":"HONDA",
        "model":"CRZ",
        "replaceby":"CRZ"
      },
      {
        "make":"HONDA",
        "model":"CR-Z",
        "replaceby":"CRZ"
      },

      {
        "make":"HYUNDAI",
        "model":"ATOS",
        "replaceby":"ATOS"
      },
      {
        "make":"HYUNDAI",
        "model":"ATOS PRIME",
        "replaceby":"ATOS"
      },

      {
        "make":"HYUNDAI",
        "model":"ELANTRA",
        "replaceby":"ELANTRA"
      },
      {
        "make":"HYUNDAI",
        "model":"ELANTRA COUPE",
        "replaceby":"ELANTRA"
      },
      {
        "make":"HYUNDAI",
        "model":"ELANTRA GT",
        "replaceby":"ELANTRA"
      },

      {
        "make":"HYUNDAI",
        "model":"GENESIS",
        "replaceby":"GENESIS"
      },
      {
        "make":"HYUNDAI",
        "model":"GENESIS COUPE",
        "replaceby":"GENESIS"
      },

      {
        "make":"HYUNDAI",
        "model":"SANTA FE",
        "replaceby":"SANTA FE"
      },
      {
        "make":"HYUNDAI",
        "model":"SANTA FE_XL",
        "replaceby":"SANTA FE"
      },

      {
        "make":"INFINITI",
        "model":"Q3",
        "replaceby":"Q3"
      },
      {
        "make":"INFINITI",
        "model":"Q3 QUATTRO",
        "replaceby":"Q3"
      },

      {
        "make":"ISUZU",
        "model":"IMARK",
        "replaceby":"IMARK"
      },
      {
        "make":"ISUZU",
        "model":"I MARK",
        "replaceby":"IMARK"
      },

      {
        "make":"ISUZU",
        "model":"PICKUP",
        "replaceby":"PICKUP"
      },
      {
        "make":"ISUZU",
        "model":"P.U.",
        "replaceby":"PICKUP"
      },
      {
        "make":"ISUZU",
        "model":"TRUCK",
        "replaceby":"PICKUP"
      },
      {
        "make":"ISUZU",
        "model":"RODEO",
        "replaceby":"RODEO"
      },
      {
        "make":"ISUZU",
        "model":"RODEO SPORT",
        "replaceby":"RODEO"
      },

      {
        "make":"JAGUAR",
        "model":"SOVEREIGN",
        "replaceby":"SOVEREIGN"
      },
      {
        "make":"JAGUAR",
        "model":"SOVEREIGN XJ6",
        "replaceby":"SOVEREIGN"
      },

      {
        "make":"JAGUAR",
        "model":"XJ12",
        "replaceby":"XJ12"
      },
      {
        "make":"JAGUAR",
        "model":"XJ-12",
        "replaceby":"XJ12"
      },

      {
        "make":"KIA",
        "model":"FORTE",
        "replaceby":"FORTE"
      },
      {
        "make":"KIA",
        "model":"FORTE KOUP",
        "replaceby":"FORTE"
      },
      {
        "make":"KIA",
        "model":"FORTE5",
        "replaceby":"FORTE"
      },

      {
        "make":"KIA",
        "model":"RIO",
        "replaceby":"RIO"
      },
      {
        "make":"KIA",
        "model":"RIO5",
        "replaceby":"RIO"
      },

      {
        "make":"KIA",
        "model":"SOUL",
        "replaceby":"SOUL"
      },
      {
        "make":"KIA",
        "model":"SOUL EV",
        "replaceby":"SOUL"
      },
      {
        "make":"KIA",
        "model":"SPECTRA",
        "replaceby":"SPECTRA"
      },
      {
        "make":"KIA",
        "model":"SPECTRA5",
        "replaceby":"SPECTRA"
      },

      {
        "make":"MAZDA",
        "model":"3",
        "replaceby":"3"
      },
      {
        "make":"MAZDA",
        "model":"3 SPORT",
        "replaceby":"3"
      },

      {
        "make":"MAZDA",
        "model":"MPV",
        "replaceby":"MPV"
      },
      {
        "make":"MAZDA",
        "model":"MPV VAN",
        "replaceby":"MPV"
      },
      {
        "make":"MAZDA",
        "model":"MPV WAGON",
        "replaceby":"MPV"
      },
      {
        "make":"MAZDA",
        "model":"MX3",
        "replaceby":"MX3"
      },
      {
        "make":"MAZDA",
        "model":"MX-3",
        "replaceby":"MX3"
      },
      {
        "make":"MAZDA",
        "model":"MX5 MIATA",
        "replaceby":"MX5 MIATA"
      },
      {
        "make":"MAZDA",
        "model":"MX-5",
        "replaceby":"MX5 MIATA"
      },
      {
        "make":"MAZDA",
        "model":"MX6",
        "replaceby":"MX6"
      },
      {
        "make":"MAZDA",
        "model":"MX-6",
        "replaceby":"MX6"
      },
      {
        "make":"MAZDA",
        "model":"NAVAJO",
        "replaceby":"NAVAJO"
      },
      {
        "make":"MAZDA",
        "model":"PICKUP",
        "replaceby":"PICKUP"
      },
      {
        "make":"MAZDA",
        "model":"P.U.",
        "replaceby":"PICKUP"
      },
      {
        "make":"MAZDA",
        "model":"PROTEGE",
        "replaceby":"PROTEGE"
      },
      {
        "make":"MAZDA",
        "model":"PROTEGE5",
        "replaceby":"PROTEGE"
      },

      {
        "make":"MAZDA",
        "model":"RX7",
        "replaceby":"RX7"
      },
      {
        "make":"MAZDA",
        "model":"RX-7",
        "replaceby":"RX7"
      },

      {
        "make":"MERCURY",
        "model":"METEOR",
        "replaceby":"METEOR"
      },
      {
        "make":"MERCURY",
        "model":"METEOR MONTCALM",
        "replaceby":"METEOR"
      },
      {
        "make":"MERCURY",
        "model":"METEOR RIDEAU",
        "replaceby":"METEOR"
      },
      {
        "make":"MERCURY",
        "model":"METEOR S33",
        "replaceby":"METEOR"
      },

      {
        "make":"MERCURY",
        "model":"PONY",
        "replaceby":"PONY"
      },
      {
        "make":"MERCURY",
        "model":"SABLE",
        "replaceby":"PONY"
      },

      {
        "make":"MERCURY",
        "model":"ZEPHYR",
        "replaceby":"ZEPHYR"
      },
      {
        "make":"MINI",
        "model":"ZEPHYR",
        "replaceby":"ZEPHYR"
      },

      {
        "make":"MINI",
        "model":"COOPER",
        "replaceby":"COOPER"
      },
      {
        "make":"MINI",
        "model":"COOPER COUNTRYMAN",
        "replaceby":"COOPER"
      },
      {
        "make":"MINI",
        "model":"COOPER PACEMAN",
        "replaceby":"COOPER PACEMAN"
      },
      {
        "make":"MINI",
        "model":"PACEMAN",
        "replaceby":"COOPER PACEMAN"
      },

      {
        "make":"MITSUBISHI",
        "model":"DELICA",
        "replaceby":"DELICA"
      },
      {
        "make":"MITSUBISHI",
        "model":"DELICA D5",
        "replaceby":"DELICA"
      },
      {
        "make":"MITSUBISHI",
        "model":"DELICA SPACE",
        "replaceby":"DELICA"
      },
      {
        "make":"MITSUBISHI",
        "model":"DELICA STAR",
        "replaceby":"DELICA"
      },

      {
        "make":"MITSUBISHI",
        "model":"EXPO",
        "replaceby":"EXPO"
      },
      {
        "make":"MITSUBISHI",
        "model":"EXPO LRV",
        "replaceby":"EXPO"
      },

      {
        "make":"MITSUBISHI",
        "model":"MONTERO",
        "replaceby":"MONTERO"
      },
      {
        "make":"MITSUBISHI",
        "model":"MONTERO SPORT",
        "replaceby":"MONTERO"
      },
      {
        "make":"MITSUBISHI",
        "model":"OUTLANDER",
        "replaceby":"OUTLANDER"
      },
      {
        "make":"MITSUBISHI",
        "model":"OUTLANDER SPORT",
        "replaceby":"OUTLANDER"
      },

      {
        "make":"MITSUBISHI",
        "model":"PICKUP",
        "replaceby":"PICKUP"
      },
      {
        "make":"MITSUBISHI",
        "model":"P.U.",
        "replaceby":"PICKUP"
      },
      {
        "make":"MITSUBISHI",
        "model":"P.U. MIGHTY MAX",
        "replaceby":"PICKUP"
      },

      {
        "make":"OLDSMOBILE",
        "model":"88",
        "replaceby":"88"
      },
      {
        "make":"OLDSMOBILE",
        "model":"88 REGENCY",
        "replaceby":"88"
      },
      {
        "make":"OLDSMOBILE",
        "model":"88 ROYALE",
        "replaceby":"88"
      },
      {
        "make":"OLDSMOBILE",
        "model":"88LS",
        "replaceby":"88"
      },
      {
        "make":"OLDSMOBILE",
        "model":"98",
        "replaceby":"98"
      },
      {
        "make":"OLDSMOBILE",
        "model":"98 REGENCY",
        "replaceby":"98"
      },
      {
        "make":"OLDSMOBILE",
        "model":"NINETY EIGHT",
        "replaceby":"98"
      },

      {
        "make":"OLDSMOBILE",
        "model":"CUTLASS CIERRA",
        "replaceby":"CUTLASS CIERRA"
      },
      {
        "make":"OLDSMOBILE",
        "model":"CUTLASS CIERA",
        "replaceby":"CUTLASS CIERRA"
      },

      {
        "make":"OLDSMOBILE",
        "model":"JETSTAR",
        "replaceby":"JETSTAR"
      },
      {
        "make":"OLDSMOBILE",
        "model":"JETSTAR 88",
        "replaceby":"JETSTAR"
      },
      {
        "make":"OLDSMOBILE",
        "model":"JETSTAR I",
        "replaceby":"JETSTAR"
      },

      {
        "make":"OLDSMOBILE",
        "model":"REGENCY",
        "replaceby":"REGENCY"
      },
      {
        "make":"OLDSMOBILE",
        "model":"REGENCY 98",
        "replaceby":"REGENCY"
      },

      {
        "make":"PONTIAC",
        "model":"G3",
        "replaceby":"G3"
      },
      {
        "make":"PONTIAC",
        "model":"G3 WAVE",
        "replaceby":"G3"
      },

      {
        "make":"PONTIAC",
        "model":"J2000",
        "replaceby":"J2000"
      },
      {
        "make":"PONTIAC",
        "model":"J2000 SUNBIRD",
        "replaceby":"J2000"
      },

      {
        "make":"PONTIAC",
        "model":"LE MANS",
        "replaceby":"LE MANS"
      },
      {
        "make":"PONTIAC",
        "model":"LEMANS",
        "replaceby":"LE MANS"
      },

      {
        "make":"PONTIAC",
        "model":"T1000",
        "replaceby":"T1000"
      },
      {
        "make":"PONTIAC",
        "model":"T-1000",
        "replaceby":"T1000"
      },

      {
        "make":"PLYMOUTH",
        "model":"BELVEDERE",
        "replaceby":"BELVEDERE"
      },
      {
        "make":"PLYMOUTH",
        "model":"BELVEDERE II",
        "replaceby":"BELVEDERE"
      },

      {
        "make":"PLYMOUTH",
        "model":"COLT",
        "replaceby":"COLT"
      },
      {
        "make":"PLYMOUTH",
        "model":"COLT VISTA",
        "replaceby":"COLT"
      },

      {
        "make":"PLYMOUTH",
        "model":"FURY",
        "replaceby":"FURY"
      },
      {
        "make":"PLYMOUTH",
        "model":"FURY I",
        "replaceby":"FURY"
      },
      {
        "make":"PLYMOUTH",
        "model":"FURY II",
        "replaceby":"FURY"
      },
      {
        "make":"PLYMOUTH",
        "model":"FURY III",
        "replaceby":"FURY"
      },
      {
        "make":"PLYMOUTH",
        "model":"FURY SALON",
        "replaceby":"FURY"
      },

      {
        "make":"PLYMOUTH",
        "model":"TURISMO",
        "replaceby":"TURISMO"
      },
      {
        "make":"PLYMOUTH",
        "model":"TORISMO",
        "replaceby":"TURISMO"
      },

      {
        "make":"PORSCHE",
        "model":"356",
        "replaceby":"356"
      },
      {
        "make":"PORSCHE",
        "model":"356B",
        "replaceby":"356"
      },

      {
        "make":"PORSCHE",
        "model":"CARRERA",
        "replaceby":"CARRERA"
      },
      {
        "make":"PORSCHE",
        "model":"CARRERA GT",
        "replaceby":"CARRERA"
      },

      {
        "make":"ROVER",
        "model":"DEFENDER",
        "replaceby":"DEFENDER"
      },
      {
        "make":"ROVER",
        "model":"DEFENDER 110",
        "replaceby":"DEFENDER"
      },
      {
        "make":"ROVER",
        "model":"DEFENDER 90",
        "replaceby":"DEFENDER"
      },
      {
        "make":"ROVER",
        "model":"DISCOVERY",
        "replaceby":"DISCOVERY"
      },
      {
        "make":"ROVER",
        "model":"DISCOVERY SPORT",
        "replaceby":"DISCOVERY"
      },

      {
        "make":"ROVER",
        "model":"RANGE",
        "replaceby":"RANGE"
      },
      {
        "make":"ROVER",
        "model":"RANGE EVOQUE",
        "replaceby":"RANGE"
      },
      {
        "make":"ROVER",
        "model":"RANGE_EVOQUE",
        "replaceby":"RANGE"
      },
      {
        "make":"ROVER",
        "model":"RANGE_SPORT",
        "replaceby":"RANGE"
      },
      {
        "make":"ROVER",
        "model":"STERLING",
        "replaceby":"RANGE"
      },

      {
        "make":"SUBARU",
        "model":"GL",
        "replaceby":"GL"
      },
      {
        "make":"SUBARU",
        "model":"GL10",
        "replaceby":"GL"
      },
      {
        "make":"SUBARU",
        "model":"GL 4WD",
        "replaceby":"GL"
      },
      {
        "make":"SUBARU",
        "model":"GL WAGON",
        "replaceby":"GL"
      },
      {
        "make":"SUBARU",
        "model":"GL-10",
        "replaceby":"GL"
      },

      {
        "make":"SUBARU",
        "model":"LEGACY",
        "replaceby":"LEGACY"
      },
      {
        "make":"SUBARU",
        "model":"LEGACY WAGON",
        "replaceby":"LEGACY"
      },

      {
        "make":"SUBARU",
        "model":"RX",
        "replaceby":"RX"
      },
      {
        "make":"SUBARU",
        "model":"RX4",
        "replaceby":"RX"
      },

      {
        "make":"SUBARU",
        "model":"WRX",
        "replaceby":"WRX"
      },
      {
        "make":"SUBARU",
        "model":"WRX STI",
        "replaceby":"WRX"
      },
      {
        "make":"SUBARU",
        "model":"XT",
        "replaceby":"XT"
      },
      {
        "make":"SUBARU",
        "model":"XT6",
        "replaceby":"XT"
      },

      {
        "make":"SUZUKI",
        "model":"FORSA",
        "replaceby":"FORSA"
      },
      {
        "make":"SUZUKI",
        "model":"FORZA",
        "replaceby":"FORSA"
      },

      {
        "make":"SUZUKI",
        "model":"SX4",
        "replaceby":"SX4"
      },
      {
        "make":"SUZUKI",
        "model":"SX4 CROSSOVER",
        "replaceby":"SX4"
      },

      {
        "make":"TOYATO",
        "model":"4RUNNER",
        "replaceby":"4RUNNER"
      },
      {
        "make":"TOYATO",
        "model":"4 RUNNER",
        "replaceby":"4RUNNER"
      },

      {
        "make":"TOYATO",
        "model":"CELICA",
        "replaceby":"CELICA"
      },
      {
        "make":"TOYATO",
        "model":"CELICA GT",
        "replaceby":"CELICA"
      },

      {
        "make":"TOYATO",
        "model":"COROLLA",
        "replaceby":"COROLLA"
      },
      {
        "make":"TOYATO",
        "model":"COROLLA IM",
        "replaceby":"COROLLA"
      },
      {
        "make":"TOYATO",
        "model":"COROLLA RUNX",
        "replaceby":"COROLLA"
      },
      {
        "make":"TOYATO",
        "model":"CORONA",
        "replaceby":"CORONA"
      },
      {
        "make":"TOYATO",
        "model":"CORONA MARK_II",
        "replaceby":"CORONA"
      },

      {
        "make":"TOYATO",
        "model":"MR2",
        "replaceby":"MR2"
      },
      {
        "make":"TOYATO",
        "model":"MR2 SPYDER",
        "replaceby":"MR2"
      },

      {
        "make":"TOYATO",
        "model":"PICKUP",
        "replaceby":"PICKUP"
      },
      {
        "make":"TOYATO",
        "model":"P.U.",
        "replaceby":"PICKUP"
      },
      {
        "make":"TOYATO",
        "model":"PICK UP",
        "replaceby":"PICKUP"
      },

      {
        "make":"TOYATO",
        "model":"PRIUS",
        "replaceby":"PRIUS"
      },
      {
        "make":"TOYATO",
        "model":"PRIUS C",
        "replaceby":"PRIUS"
      },
      {
        "make":"TOYATO",
        "model":"PRIUS PLUGIN",
        "replaceby":"PRIUS"
      },
      {
        "make":"TOYATO",
        "model":"PRIUS V",
        "replaceby":"PRIUS"
      },

      {
        "make":"TOYATO",
        "model":"T100",
        "replaceby":"T100"
      },
      {
        "make":"TOYATO",
        "model":"T-100",
        "replaceby":"T100"
      },

      {
        "make":"TOYATO",
        "model":"VAN",
        "replaceby":"VAN"
      },
      {
        "make":"TOYATO",
        "model":"VAN WAGON",
        "replaceby":"VAN"
      },

      {
        "make":"TOYATO",
        "model":"YARIS",
        "replaceby":"YARIS"
      },
      {
        "make":"TOYATO",
        "model":"YARIS IA",
        "replaceby":"YARIS"
      },

      {
        "make":"TRIUMPH",
        "model":"TR4",
        "replaceby":"TR4"
      },
      {
        "make":"TRIUMPH",
        "model":"TR4A",
        "replaceby":"TR4"
      },
      {
        "make":"TRIUMPH",
        "model":"TR6",
        "replaceby":"TR6"
      },
      {
        "make":"TRIUMPH",
        "model":"TR-6",
        "replaceby":"TR6"
      },
      {
        "make":"TRIUMPH",
        "model":"TR7",
        "replaceby":"TR7"
      },
      {
        "make":"TRIUMPH",
        "model":"TR-7",
        "replaceby":"TR7"
      },

      {
        "make":"VOLKSWAGEN",
        "model":"DASHER",
        "replaceby":"DASHER"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"DASHER- DIESEL",
        "replaceby":"DASHER"
      },

      {
        "make":"VOLKSWAGEN",
        "model":"GOLF",
        "replaceby":"GOLF"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"GOLF CITY",
        "replaceby":"GOLF"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"GOLF GTI",
        "replaceby":"GOLF"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"GOLF R",
        "replaceby":"GOLF"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"GTI",
        "replaceby":"GTI"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"GT1",
        "replaceby":"GTI"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"JETTA",
        "replaceby":"JETTA"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"JETTA CITY",
        "replaceby":"JETTA"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"JETTA GLI",
        "replaceby":"JETTA"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"KARMANN GHIA",
        "replaceby":"KARMANN GHIA"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"KARMENGHIA",
        "replaceby":"KARMANN GHIA"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"PASSAT",
        "replaceby":"PASSAT"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"PASSAT CC",
        "replaceby":"PASSAT"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"PICKUP",
        "replaceby":"PICKUP"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"PU",
        "replaceby":"PICKUP"
      },

      {
        "make":"VOLKSWAGEN",
        "model":"RABBIT",
        "replaceby":"RABBIT"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"RABBIT CONVERTIBLE",
        "replaceby":"RABBIT"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"RABBIT PICKUP",
        "replaceby":"RABBIT PICKUP"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"RABBIT TRUCK",
        "replaceby":"RABBIT PICKUP"
      },

      {
        "make":"VOLKSWAGEN",
        "model":"SQUAREBACK",
        "replaceby":"SQUAREBACK"
      },
      {
        "make":"VOLKSWAGEN",
        "model":"SQUARE BACK",
        "replaceby":"SQUAREBACK"
      },

      {
        "make":"VOLVO",
        "model":"260",
        "replaceby":"260"
      },
      {
        "make":"VOLVO",
        "model":"260 SERIES",
        "replaceby":"260"
      },

      {
        "make":"VOLVO",
        "model":"70",
        "replaceby":"70"
      },
      {
        "make":"VOLVO",
        "model":"70 SERIES",
        "replaceby":"70"
      },

      {
        "make":"VOLVO",
        "model":"80",
        "replaceby":"80"
      },
      {
        "make":"VOLVO",
        "model":"80 SERIES",
        "replaceby":"80"
      },

      {
        "make":"VOLVO",
        "model":"V60",
        "replaceby":"V60"
      },
      {
        "make":"VOLVO",
        "model":"V60 CROSS_COUNTRY",
        "replaceby":"V60"
      },
];


// WEBPACK FOOTER //
// ./src/store/data/modelList.ts